import api from "./api";

const publicLeaveService = {
    getColleges: () => api.get("/colleges/public"),
    getEmployees: (collegeId) => api.get("/public/leave/employees", { params: { college: collegeId } }),
    requestOtp: (employeeId) => api.post("/public/leave/request-otp", { employeeId }),
    verifyOtp: (employeeId, otp) => api.post("/public/leave/verify-otp", { employeeId, otp }),
    getLeaveTypes: (employeeId, token) =>
        api.get("/public/leave/leave-types", { params: { employeeId, token } }),
    submit: (data) => api.post("/public/leave/submit", data),
};

export default publicLeaveService;